import React from 'react';
import {PersistGate} from 'redux-persist/integration/react'
import RouterAdopta from "./RouterAdopta";
import * as Sentry from "@sentry/react";
import Head from "@/modules/Structure/components/Head";


function AppAdopta(props) {
    console.log("AppAdopta::AppAdopta()")
    return (
        <PersistGate persistor={props.persistor}>
            <Head/>
            <RouterAdopta/>
        </PersistGate>
    );
}

export default Sentry.withProfiler(AppAdopta)

